import React from "react";
import { CircleAlert, CircleCheck, Info } from "lucide-react";
import { cx } from "components/crm/ui/uiUtils";

const BANNERS = {
  success: ["bg-success-soft text-success-text", CircleCheck],
  warning: ["bg-warning-bg text-warning-fg", CircleAlert],
  info: ["bg-[#eff6ff] text-[#1d4ed8]", Info],
};

const Banner = ({ tone = "success", children }) => {
  const [classes, Icon] = BANNERS[tone];
  return (
    <div
      className={cx(
        "flex items-start gap-3 rounded-xl px-6 py-4 text-sm font-medium leading-5",
        classes
      )}
    >
      <Icon size={20} className="mt-0.5 shrink-0" strokeWidth={2} />
      <p>{children}</p>
    </div>
  );
};

export default Banner;
